import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { CtaButton } from '../CtaButton';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-bone px-4 py-14 sm:px-6 sm:py-20" data-id="element-155" data-mp="x5d1eixhg2eb">
      <div className="mx-auto w-full max-w-2xl" data-id="element-156" data-mp="123oausjv8aw0">
        <div className="text-center" data-id="element-157" data-mp="124g785laecnc">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.24em] text-blood" data-id="element-158" data-mp="1prxubntlwmjz">
            FAQ
          </p>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-159" data-mp="1upzfcealevy3">
            Frequently asked questions
          </h2>
        </div>

        <ul className="mt-9 flex flex-col gap-3" data-id="element-160" data-mp="1l0pikl4t0p3n">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} className="overflow-hidden rounded-2xl bg-white shadow-card ring-1 ring-ink/[0.07]" data-id="element-161" data-mp="28p8qv0nut1vq" data-mpi={index}>
                <h3 data-id="element-162" data-mp="2oqqohjwz0rjm">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-cream/60 sm:px-5" data-id="element-163" data-mp="2oo4jns1gsq53">
                    <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-164" data-mp="37foyzscl720k">
                      {faq.q}
                    </span>
                    <ChevronDownIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 shrink-0 text-blood transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-165" data-mp="32jq2fhh3udp2" />
                  </button>
                </h3>
                {isOpen ? <p className="border-t border-ink/[0.07] px-4 py-4 text-[14px] leading-relaxed text-graphite/80 sm:px-5 sm:text-[15px]" data-id="element-166" data-mp="1i33k0w7hafha">
                    {faq.a}
                  </p> : null}
              </li>;
        })}
        </ul>

        <div className="mt-9 flex justify-center" data-id="element-167" data-mp="2gq2s98ztu23c">
          <CtaButton label="My questions are answered — I want to start" data-id="element-168" data-mp="2gpaxg0e208e4" />
        </div>
      </div>
    </section>;
}